import { browser } from '$app/environment';
import { getAuth } from 'firebase/auth';
import { firestoreDb } from '$lib/firebase';
import { collection, query, where, getDocs, limit, orderBy, getDoc, doc } from 'firebase/firestore';
import { createUserDoc } from './createUserDoc';
import { logError } from '$lib/helpers/errors';

export async function checkUserObject(uid) {
	let user = null;
	if (!browser || !uid || !firestoreDb) {
		return;
	}
	try {
		const firestore = await firestoreDb();

		const docRef = doc(firestore, 'users', uid);

		const docSnap = await getDoc(docRef);
		if (docSnap.exists()) {
			user = docSnap.data();
		}
		// console.log("Document data:", user);
	} catch (error) {
		console.log('checkUserObject error: ', error);
		logError(error, 'firestore:checkUserObject');
	}
	return user;
}
